import { GraphQLClient } from '@mineko/graphql-client';
let client: GraphQLClient;

export const initClient = (apiUrl: string): void => {
  client = new GraphQLClient(apiUrl);
};

export default (): GraphQLClient => {
  if (!client) {
    throw Error('Client needs to be initialised with the api url');
  }
  return client;
};
